import { render, staticRenderFns } from "./moreArticles.vue?vue&type=template&id=debf76d4&scoped=true&"
import script from "./moreArticles.vue?vue&type=script&lang=js&"
export * from "./moreArticles.vue?vue&type=script&lang=js&"
import style0 from "./moreArticles.vue?vue&type=style&index=0&id=debf76d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "debf76d4",
  null
  
)

export default component.exports